import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Layout({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      {/* Navbar */}
      <header className="bg-black py-2 border-b-4 border-white sticky top-0 z-50">
        <div className="container mx-auto flex items-center justify-between px-4">
          {/* Left Section */}
          <nav className="hidden lg:flex flex-1 space-x-4 text-white text-lg font-semibold">
            <Link to="/" className="hover:text-blue-600">Book a Ride</Link>
            <Link to="/managebooking" className="hover:text-blue-600">Manage Booking</Link>
            <Link to="/faqs" className="cursor-pointer hover:text-blue-600">FAQs</Link>
          </nav>

          {/* Animated Logo Section */}
          <Link to="/">
            <div className="flex-none text-center relative group h-16 flex lg:justify-center items-center">
              {/* Default Text (KAR) */}
              <span className="absolute text-4xl md:text-6xl font-bold duration-300">
                KAR
              </span>

             {/* //Animated Text (Kelowna Auto Rentals)
              <span className="absolute text-xl md:text-2xl font-semibold flex space-x-1 opacity-0 group-hover:opacity-100">
                //Each letter with its animation
                <span className="inline-block animate-slide-out">K</span>
                <span className="inline-block animate-slide-out delay-[100ms]">e</span>
                <span className="inline-block animate-slide-out delay-[200ms]">l</span>
                <span className="inline-block animate-slide-out delay-[300ms]">o</span>
                <span className="inline-block animate-slide-out delay-[400ms]">w</span>
                <span className="inline-block animate-slide-out delay-[500ms]">n</span>
                <span className="inline-block animate-slide-out delay-[600ms]">a</span>
                <span className="inline-block animate-slide-out delay-[600ms]"> </span>
                <span className="inline-block ml-1 animate-slide-out delay-[700ms]">A</span>
                <span className="inline-block animate-slide-out delay-[800ms]">u</span>
                <span className="inline-block animate-slide-out delay-[900ms]">t</span>
                <span className="inline-block animate-slide-out delay-[1000ms]">o </span>
                <span className="inline-block animate-slide-out delay-[600ms]"> </span>
                <span className="inline-block ml-1 animate-slide-out delay-[1100ms]">R</span>
                <span className="inline-block animate-slide-out delay-[1200ms]">e</span>
                <span className="inline-block animate-slide-out delay-[1300ms]">n</span>
                <span className="inline-block animate-slide-out delay-[1400ms]">t</span>
                <span className="inline-block animate-slide-out delay-[1500ms]">a</span>
                <span className="inline-block animate-slide-out delay-[1600ms]">l</span>
                <span className="inline-block animate-slide-out delay-[1700ms]">s</span>
              </span> */}
            </div>
          </Link>

          {/* Right Section */}
          <nav className="hidden lg:flex flex-1 justify-end space-x-4 text-white text-lg font-semibold">
            <Link to="/about" className="cursor-pointer hover:text-blue-600">About Us</Link>
            <Link to="/contact" className="cursor-pointer hover:text-blue-600">Contact Us</Link>
            <Link to="/testimonials" className="hover:text-blue-600">Testimonials</Link>
          </nav>

          {/* Hamburger Menu Button */}
          <button
            className="text-white lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {/* Dropdown Menu for Smaller Screens */}
        {isMenuOpen && (
          <nav className="absolute top-14 left-0 w-full bg-black border-t border-white lg:hidden">
            <ul className="flex flex-col items-center space-y-2 py-4 text-white">
              <li><Link to="/" className="cursor-pointer hover:text-blue-600">Book a Ride</Link></li>
              <li><Link to="/managebooking" className="hover:text-blue-600">Manage Booking</Link></li>
              <li><Link to="/faqs" className="cursor-pointer hover:text-blue-600">FAQs</Link></li>
              <li><Link to="/about" className="cursor-pointer hover:text-blue-600">About Us</Link></li>
              <li><Link to="/contact" className="cursor-pointer hover:text-blue-600">Contact Us</Link></li>
              <li><Link to="/testimonials" className="hover:text-blue-600">Testimonials</Link></li>
              <li><Link to="/fleet" className="hover:text-blue-600">Our Fleet</Link></li>
            </ul>
          </nav>
        )}
      </header>

      {/* Main Content */}
      <main className="flex-grow">{children}</main>

      <footer className="bg-black py-4 border-t-2 border-white">
        <div className="container mx-auto px-4">
          {/* Desktop Layout (Default for Larger Screens) */}
          <div className="hidden lg:flex lg:flex-row md:items-center lg:justify-between text-sm">
            {/* Left Section: Copyright */}
            <div className="text-[10px]">
              © 2025 Kelowna Auto Rentals Ltd. All rights reserved.
            </div>

            {/* Middle Section: Policy Links */}
            <nav className="absolute left-1/2 transform -translate-x-1/2 text-xs lg:text-sm font-semibold">
              <a href="/franchise" target="_blank" className="hover:underline mx-2">Franchise</a>
              <span className="text-white">|</span>
              <a href="https://drive.google.com/file/d/19AEqpT_aszYBo8RxES6KsIzH_RiOFH-i/view?usp=sharing" download target="_blank" rel="noopener noreferrer" className="hover:underline mx-2">Privacy Policy</a>
              <span className="text-white">|</span>
              <a href="https://drive.google.com/file/d/184xj4cMqj9xV8sWHvNnCyhVtKaVAOHfD/view?usp=sharing" download target="_blank" rel="noopener noreferrer" className="hover:underline mx-2">Terms of Service</a>
            </nav>

            {/* Right Section: Social Icons */}
            <div className="flex justify-end space-x-4">
              <a href="https://www.instagram.com/kar.rentals/" target="_blank" rel="noopener noreferrer">
                <img src="/socials/instagram_logo.svg" alt="Instagram" className="w-5 h-5 md:w-6 md:h-6" />
              </a>
              {/* <a href="https://www.instagram.com/kar.rentals/" target="_blank" rel="noopener noreferrer">
                <img src="/socials/facebook_logo.svg" alt="Facebook" className="w-5 h-5 md:w-6 md:h-6" />
              </a> */}
              {/* <a href="https://www.instagram.com/kar.rentals/" target="_blank" rel="noopener noreferrer">
                <img src="/socials/linkedIn_logo.svg" alt="LinkedIn" className="w-5 h-5 md:w-6 md:h-6" />
              </a> */}
            </div>
          </div>

          {/* Mobile/Tablet Layout (For Smaller Screens) */}
          <div className="flex flex-col lg:hidden items-center justify-between text-sm">
            {/* Top Row: Policy Links */}
            <nav className="flex flex-wrap justify-center space-x-4 space-t-4 text-xs font-semibold mb-2">
              <a href="/franchise" target="_blank" className="hover:underline mx-2">Franchise</a>
              <span className="text-white">|</span>
              <a href="https://drive.google.com/file/d/19AEqpT_aszYBo8RxES6KsIzH_RiOFH-i/view?usp=sharing" download target="_blank" rel="noopener noreferrer" className="hover:underline mx-2">Privacy Policy</a>
              <span className="text-white">|</span>
              <a href="https://drive.google.com/file/d/184xj4cMqj9xV8sWHvNnCyhVtKaVAOHfD/view?usp=sharing" download target="_blank" rel="noopener noreferrer" className="hover:underline mx-2">Terms of Service</a>
            </nav>

            {/* Middle Row: Social Icons */}
            <div className="flex justify-center space-x-4 mb-2">
              <a href="https://www.instagram.com/kar.rentals/" target="_blank" rel="noopener noreferrer">
                <img src="/socials/instagram_logo.svg" alt="Instagram" className="w-5 h-5" />
              </a>
              {/* <a href="https://www.instagram.com/kar.rentals/" target="_blank" rel="noopener noreferrer">
                <img src="/socials/facebook_logo.svg" alt="Facebook" className="w-5 h-5" />
              </a> */}
              {/* <a href="https://www.instagram.com/kar.rentals/" target="_blank" rel="noopener noreferrer">
                <img src="/socials/linkedIn_logo.svg" alt="LinkedIn" className="w-5 h-5" />
              </a> */}
            </div>

            {/* Bottom Row: Copyright */}
            <div className="text-[10px] text-center">
              © 2025 Kelowna Auto Rentals Ltd. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;